import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({

    /* ===== Layout ===== */
    appBarSpacer: {
        minHeight: '82px',
        background: '#fff',
    },

    header: {
        background: '#CEDDFF',
        borderBottom: '1px solid #4D80C9',
        display: 'flex',
        alignItems: 'center',
        height: '49px',
        paddingLeft: '15px',
    },

    container: {
        padding: '15px',
        background: '#fbfbfb',
    },

    gridHeader: {
        padding: '6px 15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
    },

    gridActions: {
        textAlign: 'right',
    },

    selectFilter: {
        border: '1px solid #4d80c9',
        borderRadius: '5px',
        background: 'white',
        marginRight: '7px',
        "& select": {
            padding: '8px 10px',
            margin: 0,
            fontSize: '14px',
        }
    },

    /* ===== Checkbox ===== */
    checkBoxFormLabel: {
        margin: '6px',
    },

    checkBoxBtn: {
        display: 'none', // hide checkbox UI
    },

    /* ===== Status Boxes Container ===== */
    statusBoxContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        width: '100%',
    },

    /* ===== Base Status Card ===== */
    statusCard: {
        minWidth: '150px',
        borderRadius: '12px',
        padding: '12px',
        cursor: 'pointer',
        border: '1px solid transparent',
        transition: 'all 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }
    },
    activeStatusCard: {
        border: '1px solid currentColor',
        boxShadow: '0 0 10px rgba(0,0,0,0.15)',
        transform: 'translateY(-2px)',
    },
    statusCardInner: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },

    statusIconWrap: {
        fontSize: '20px',
        display: 'flex',
        alignItems: 'center',
    },

    statusBoxContent: {
        "& h5": {
            margin: 0,
            fontSize: '13px',
            fontWeight: 600,
        },
        "& h2": {
            margin: 0,
            fontSize: '20px',
            fontWeight: 700,
        }
    },

    /* ===== STATUS COLORS ===== */

    /* TOTAL */
    total: {
        background: '#E6F0FF',
        "& h5, & h2": { color: '#1D39C4' },
    },

    /* RINGING */
    ringing: {
        background: '#BAE7FF',
        "& h5, & h2": { color: '#096DD9' },
    },

    /* IN PROGRESS */
    "in-progress": {
        background: '#B5F5EC',
        "& h5, & h2": { color: '#08979C' },
    },

    /* COMPLETED */
    completed: {
        background: '#D9F7BE',
        "& h5, & h2": { color: '#389E0D' },
    },

    /* BUSY */
    busy: {
        background: '#FFCCC7',
        "& h5, & h2": { color: '#CF1322' },
    },

    /* FAILED */
    failed: {
        background: '#FFA39E',
        "& h5, & h2": { color: '#A8071A' },
    },

    /* MISSED */
    "no-answer": {
        background: '#FFF1B8',
        "& h5, & h2": { color: '#AD8B00' },
    },

    /* ===== Selected (Checked) Effect ===== */
    "@global": {
        ".MuiCheckbox-root.Mui-checked + span > div": {
            border: '1px solid #000',
            boxShadow: '0 0 8px rgba(0,0,0,0.15)',
        }
    }

}));